import * as bootstrap from "bootstrap";

// Funzione generica per attivare tab tramite hash
export function attivaTabDaHash(tabContainerSelector: string, titleSelector: string | null = null, defaultTabId: string | null = null): void {
    let isInitialLoad = true;

    // Funzione per attivare il tab in base all'hash nell'URL
    function activateTab(): void {
        let hash = window.location.hash.substring(1);

        if (!hash && defaultTabId) {
            hash = defaultTabId;
        }

        const tabButton = document.querySelector(`${tabContainerSelector} #${hash}-tab`) as HTMLElement;
        if (tabButton) {
            const bsTab = new bootstrap.Tab(tabButton);
            bsTab.show();

            if (titleSelector) {
                const titolo = tabButton.querySelector(".d-none.d-md-block")?.textContent || "";
                const titleElement = document.querySelector(titleSelector);
                if (titleElement) titleElement.textContent = titolo;
            }

            // Trigghera manualmente l'evento shown.bs.tab se è il caricamento iniziale
            // Questo garantisce che i listener dell'evento vengano eseguiti anche al primo load
            if (isInitialLoad) {
                // Usa setTimeout per assicurarsi che l'evento venga triggerato dopo che il tab è stato mostrato
                setTimeout(() => {
                    const event = new Event('shown.bs.tab', { bubbles: true });
                    tabButton.dispatchEvent(event);
                }, 100);
            }
        }
    }

    // Attiva il tab iniziale
    activateTab();
    isInitialLoad = false;

    // Gestisci i cambiamenti di hash
    window.addEventListener("hashchange", activateTab);

    // Aggiorna il titolo quando si cambia tab manualmente
    const tabs = document.querySelectorAll(`${tabContainerSelector} button[data-bs-toggle="tab"]`);
    tabs.forEach(tab => {
        tab.addEventListener('shown.bs.tab', function(event) {
            const target = event.target as HTMLElement;
            if (titleSelector) {
                const titolo = target.querySelector(".d-none.d-md-block")?.textContent || "";
                const titleElement = document.querySelector(titleSelector);
                if (titleElement) titleElement.textContent = titolo;
            }

            const tabId = target.id.replace('-tab', '');
            history.replaceState("", "", `#${tabId}`);
        });
    });
}

